<section class="service-cell">
  @if (params) {
    <div class="body-2-bold ellipsis" [ngClass]="titleContainerClass">
      @if (checkIsNew()) {
        <span
          class="inline-display"
          raUiBadge="."
          [badgeConfig]="{
            position: BadgePosition.Before,
            color: BADGE_STATUS_COLORS.Information,
            size: BadgeSize.Indicator,
          }"
        ></span>
      }
      <span [ngClass]="greyOutText ? 'grey-out' : ''">{{ title }}</span>
    </div>
  }
  <div class="body-2 ellipsis" [ngStyle]="{ 'padding-bottom': toggle ? '10px' : '' }">
    @if (toggle && params) {
      <div [ngClass]="greyOutText ? 'grey-out' : ''">Trial ID: {{ params.data.id }}</div>
      @if (showAllocationDetails) {
        <div [ngClass]="greyOutText ? 'grey-out' : ''">
          <div>Allocated on: {{ params.data.allocatedOn | customDate }}</div>
          <div>Allocated by: {{ params.data.allocatedByUserEmail }}</div>
        </div>
      }
      @if (showAllocatedByLink) {
        @if (params.data.allocatedByUserEmail) {
          <div>
            Allocated By:
            <a [routerLink]="allocatedByRouterLink">{{ params.data.allocatedByUserEmail }}</a>
          </div>
        }
        @if (params.data.allocatedOn) {
          <div>Allocated On: {{ params.data.allocatedOn }}</div>
        }
      }
      <span class="toggle" (click)="toggleDetails()"
        >Details <i class="ra-icon-ide-sm-chevron-up align-middle"></i>
      </span>
    } @else {
      <span class="toggle" (click)="toggleDetails()"
        >Details <i class="ra-icon-ide-sm-chevron-down align-middle"></i>
      </span>
    }
  </div>
</section>
